import { NormalTextInputField } from "@/components";
import { useMemo } from "react";

const HomeSocialMediaSectionFormField = ({
  isFetching,
  stateDetails,
  handleTextInputChange,
}) => {
  return (
    <>
      {/* Heading */}
      <NormalTextInputField
        isFetching={isFetching}
        labelText="Heading"
        fieldId="home-section-7-social-media-heading"
        fieldName="home-section-7-social-media-heading"
        placeholderText="Heading"
        inputValue={stateDetails?.["home-section-7-social-media-heading"] || ""}
        onChangeTextInputField={handleTextInputChange}
        translateField={true}
      />
    </>
  );
};

export default HomeSocialMediaSectionFormField;
